import gaimg from "./images/SVGImgs/Watertap.svg";
import gbimg from "./images/SVGImgs/Polution.svg";
import gcimg from "./images/SVGImgs/soundpolution.svg";
import gdimg from "./images/SVGImgs/Drainage.svg";
import geimg from "./images/SVGImgs/Agriculture.svg";
import gfimg from "./images/SVGImgs/Irrigation.svg";
import ggimg from "./images/SVGImgs/Land.svg";
import ghimg from "./images/SVGImgs/De-forestation.svg";

export const HeaderComponentHeadText = "ఆన్‌లైన్ పంచాయతీ రాజ్ సహాయ కేంద్రం";
// export const HeaderComponentHeadText = "Welcome To Grievance Help Desk";

export const MainPageHeadText = "ఫిర్యాదును ఎంచుకోండి";
// export const MainPageHeadText = "Select a Grievance";

export const Grievances = [
    {
        GrievanceA:"త్రాగు నీటి సమస్య",
        GrievanceAImg:gaimg,
        GrievanceAE:"Water Issue",
    },
    {
        GrievanceB:"వాయు కాలుష్యం సమస్య",
        GrievanceBImg:gbimg,
        GrievanceBE:"Air Pollution",
    },
    {
        GrievanceC:"ధ్వని కాలుష్యం సమస్య",
        GrievanceCImg:gcimg,
        GrievanceCE:"Sound Pollution",
    },
    {
        GrievanceD:"డ్రైనేజీ సమస్య",
        GrievanceDImg:gdimg,
        GrievanceDE:"Drainage Issue",
    },
    {
        GrievanceE:"వ్యవసాయ సమస్య",
        GrievanceEImg:geimg,
        GrievanceEE:"Agriculture Issue",
    },
    {
        GrievanceF:"నీటిపారుదల సమస్య",
        GrievanceFImg:gfimg,
        GrievanceFE:"Irrigation Issue",
    },
    {
        GrievanceG:"భూమి సమస్య",
        GrievanceGImg:ggimg,
        GrievanceGE:"Land Issue",
    },
    {
        GrievanceH:"అటవీ నిర్మూలన సమస్య",
        GrievanceHImg:ghimg,
        GrievanceHE:"Deforestation",
    },
]

